import platform from 'platform'
import acceptedlanguages from 'acceptedlanguages'
import moment from 'moment'
import baseApi from '../api/common/baseApi.js'
import storage from './storage.js'
import { time } from 'console'

const helper = {
	getRangeInt(fromInt, toInt) {
		let listInts = []
		if (fromInt <= toInt) {
			for (let i = fromInt; i <= toInt; i++) {
				listInts.push(i)
			}
		}
		return listInts
	},

	addDays(date, days) {
		var result = new Date(date)
		result.setDate(result.getDate() + days)
		return result
	},

	addYears(date, years) {
		var result = new Date(date)
		result.setFullYear(result.getFullYear() + years)
		return result
	},

	compareDate(d1, d2) {
		const dt1 = new Date(d1)
		const dt2 = new Date(d2)

		if (dt1.getDate() > dt2.getDate()) {
			return 1
		}

		if (dt1.getDate() < dt2.getDate()) {
			return -1
		}

		return 0
	},

	arrStr2Num(arrStr) {
		let arrNum = arrStr.map((s) => Number(s))
		return arrNum
	},

	validateAgePolicy(dateOfBirth, minAge, maxAge) {
		let age = this.getAge(new Date(dateOfBirth))
		let result = {
			isValid: true,
			message: '',
		}
		if (minAge !== null && maxAge !== null && (age < minAge || age > maxAge)) {
			result.isValid = false
			result.message = `Age must be between ${minAge} and ${maxAge}`
		}

		return result
	},

	validateRelationshipToPolicyHolder(
		policyHolderInsured,
		occupationId,
		occupationOptionData,
		relationshipToPolicyHolderId,
		relationshipOptionData,
	) {
		let result = {
			isValid: true,
			message: '',
		}

		var relationshipToPolicyHolder = relationshipOptionData.find(
			(r) => r.value == relationshipToPolicyHolderId,
		).text

		if (
			policyHolderInsured &&
			(relationshipToPolicyHolder === 'Son' || relationshipToPolicyHolder === 'Daughter')
		) {
			var occupation = occupationOptionData.find((occ) => occ.value == occupationId).text
			if (occupation !== 'Child 18 - 24 in education') {
				result.isValid = false
				result.message =
					'Children between the ages of 18 and 25 MUST be in full time education to be on the policy, otherwise they will require their own policy.'
			}
		}

		return result
	},

	getAge(birthDate) {
		var today = new Date()
		var age = today.getFullYear() - birthDate.getFullYear()
		var m = today.getMonth() - birthDate.getMonth()
		if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
			age--
		}
		return age
	},

	blob2Base64(blob) {
		return new Promise((resolve, _) => {
			const reader = new FileReader()
			reader.onloadend = () => resolve(reader.result)
			reader.readAsDataURL(blob)
		})
	},

	base642Blob(contentType, base64Data, sliceSize = 512) {
		const byteCharacters = atob(base64Data)
		const byteArrays = []

		for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
			const slice = byteCharacters.slice(offset, offset + sliceSize)

			const byteNumbers = new Array(slice.length)
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i)
			}

			const byteArray = new Uint8Array(byteNumbers)
			byteArrays.push(byteArray)
		}

		const blob = new Blob(byteArrays, { type: contentType })
		return blob
	},

	file2Base64(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader()
			reader.readAsDataURL(file)
			reader.onload = () => resolve(reader.result)
			reader.onerror = (error) => reject(error)
		})
	},

	async base642File(url, filename, mimeType) {
		const res = await fetch(url)
		const buf = await res.arrayBuffer()
		return new File([buf], filename, { type: mimeType })
	},

	getBase64Extension(base64Data) {
		return base64Data.split(';')[0].split('/')[1]
	},

	getBase64ContentType(base64Data) {
		return base64Data.split(';')[0].split(':')[1]
	},

	getBaseAssetPath() {
		return location.pathname + (process.env.NODE_ENV == 'production' ? '/dist/' : '')
	},

	sortByFieldName(obj) {
		return Object.keys(obj)
			.sort()
			.reduce(function (result, key) {
				if (obj[key] === null) {
					result[key] = null
				} else {
					result[key] = obj[key]
				}
				return result
			}, {})
	},

	sortObj(obj, sortedFields = [], parentField = '') {
		for (var o in obj) {
			if (obj[o] !== null && obj[o] !== undefined && typeof obj[o] === 'object') {
				obj[o] = this.sortObj(obj[o], sortedFields, o)
			}
		}

		if (sortedFields.length && parentField !== '') {
			if (sortedFields.includes(parentField)) {
				return this.sortByFieldName(obj)
			}

			return obj
		}

		return this.sortByFieldName(obj)
	},

	/**
	 * Deep clone date from source object to destination object
	 * @param {*} sourObj Source object
	 * @param {*} desObj Destination object
	 * @param {*} excludes exclude fields not copy
	 * @returns
	 */
	copy(sourObj, desObj, excludes = []) {
		for (var attr in sourObj) {
			if (sourObj[attr] !== null && sourObj[attr] !== undefined) {
				if (desObj.hasOwnProperty(attr) && !excludes.includes(attr)) {
					if (Array.isArray(sourObj[attr])) {
						if (desObj[attr].length) {
							for (let i = 0; i < sourObj[attr].length; i++) {
								if (typeof sourObj[attr][i] === 'object' && Object.keys(desObj[attr]).length) {
									desObj[attr][i] = this.copy(sourObj[attr][i], desObj[attr][i])
								} else {
									desObj[attr][i] = sourObj[attr][i]
								}
							}
						} else {
							desObj[attr] = sourObj[attr]
						}
					}

					if (typeof sourObj[attr] === 'object' && Object.keys(desObj[attr]).length) {
						desObj[attr] = this.copy(sourObj[attr], desObj[attr])
					} else {
						desObj[attr] = sourObj[attr]
					}
				}
			}
		}

		return desObj
	},

	addFieldToObj(obj, key, value, index) {
		// Create a temp object and index variable
		var temp = {}
		var i = 0

		// Loop through the original object
		for (var prop in obj) {
			if (obj.hasOwnProperty(prop)) {
				// If the indexes match, add the new item
				if (i === index && key && value) {
					temp[key] = value
				}

				// Add the current item in the loop to the temp obj
				temp[prop] = obj[prop]

				// Increase the count
				i++
			}
		}

		// If no index, add to the end
		if (!index && key && value) {
			temp[key] = value
		}

		return temp
	},

	getCookie(cname) {
		var name = cname + '='
		var decodedCookie = decodeURIComponent(document.cookie)
		var ca = decodedCookie.split(';')
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i]
			while (c.charAt(0) === ' ') {
				c = c.substring(1)
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length)
			}
		}
		return ''
	},

	isExist(name) {
		var decodedCookie = decodeURIComponent(document.cookie)
		var ca = decodedCookie.split(';')
		for (var i = 0; i < ca.length; i++) {
			var cKey = ca[i].split('=')[0]
			if (cKey.includes(name)) return true
		}
		return false
	},

	getAntiForgeryToken() {
		return window.antiForgeryToken
	},

	groupByField(data, key) {
		const res = data.reduce((arr, curr) => {
			if (!arr[curr[key]]) arr[curr[key]] = [] //If this type wasn't previously stored
			arr[curr[key]].push(curr)
			return arr
		}, {})

		return res
	},

	multiLanguageDisplay(source, separator = '<br>') {
		let message = ''
		source.map((item, index) => {
			index % 2 == 0 ? (message += item + separator) : (message += item)
		})

		return message
	},

	displayDualLanguage(original, translation, separator = '<br>', locale) {
		if (locale != 'en') return original + separator + translation
		return original
	},

	changeDateFormat(object, format = 'DD-MM-YYYY') {
		let array = object

		for (const key in array) {
			if (typeof array[key] === 'object' && Object.keys(array[key]).length) {
				array[key] = this.changeDateFormat(array[key], format)
			} else {
				if (moment(array[key], 'YYYY-MM-DD', true).isValid()) {
					array[key] = moment(array[key], 'Y-M-D').format(format)
				}
			}
		}

		return array
	},

	async stepLogs(step, data) {
		try {
			await baseApi.post('api/stepLogs', {
				step,
				data: JSON.stringify(data),
			})
		} catch (e) {
			console.log(e)
		}
	},

	getTimestamps() {
		try {
			return new Date()
		} catch (e) {
			return ''
		}
	},

	getElapsedTime(startTime, endTime) {
		try {
			const FStartTime = moment.utc(startTime)
			const FEndTime = moment.utc(endTime)

			const elapsedTime = FEndTime - FStartTime

			const days = Math.floor(elapsedTime / (1000 * 60 * 60 * 24))
			const hours = Math.floor((elapsedTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
			const minutes = Math.floor((elapsedTime % (1000 * 60 * 60)) / (1000 * 60))
			const seconds = Math.floor((elapsedTime % (1000 * 60)) / 1000)

			return `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`
		} catch (e) {
			return ''
		}
	},

	checkTimeOut(startTime, appSubmitTimeLimit = 30) {
		try {
			const FStartTime = moment.utc(startTime)
			const FEndTime = moment.utc()

			const timeElapsed = FEndTime.diff(FStartTime, 'minutes')

			return timeElapsed >= appSubmitTimeLimit - 2 ? true : false
		} catch (e) {
			console.log(e)
			return false
		}
	},

	logStepTimestamps(step, startTime, endTime) {
		try {
			const stepStartTime = storage.getSession('stepStartTime') || startTime
			storage.setSession('stepStartTime', endTime)

			let applicationTime = storage.getSession('applicationTime') || {
				startTime: this.formatApplicationTime(startTime),
				steps: {},
				endTime: '',
				elapsedTime: '',
			}

			applicationTime = {
				...applicationTime,
				steps: { ...applicationTime.steps, [step]: this.getElapsedTime(stepStartTime, endTime) },
				endTime: this.formatApplicationTime(endTime),
				elapsedTime: this.getElapsedTime(startTime, endTime),
			}

			this.userActivity(step)
			storage.setSession('applicationTime', applicationTime)
		} catch (e) {
			console.log(e)
		}
	},

	userActivity(step) {
		const steps = {
			1: 'Policy Holder Details',
			2: 'Product',
			3: 'Details',
			4: 'Underwriting Questions',
			5: 'Apply',
		}

		let userActivity = storage.getSession('userActivity') || []
		userActivity.push(`Step ${step} - ${steps[step]}`)
		storage.setSession('userActivity', userActivity)
	},

	formatApplicationTime(timestamps) {
		if (timestamps == '' || timestamps == null) {
			return ''
		}

		const momemtObj = moment.utc(timestamps)
		return momemtObj.format('DD/MM/YYYY HH:mm:ss')
	},

	/**
	 * Handle default selected value: convert to null if empty value
	 */
	handleDefauSelectValue(originalSrc, searchKeys) {
		let objSrc = originalSrc
		for (const key in objSrc) {
			if (typeof objSrc[key] === 'object') {
				if (Array.isArray(objSrc[key])) {
					for (const iKey in objSrc[key]) {
						let item = objSrc[key][iKey]
						if (typeof item === 'object') {
							item = this.handleDefauSelectValue(item, searchKeys)
						} else {
							if (searchKeys.includes(key) && item == '') {
								item = null
							}
						}
					}
				} else {
					objSrc[key] = this.handleDefauSelectValue(objSrc[key], searchKeys)
				}
			} else {
				if (searchKeys.includes(key) && objSrc[key] == '') {
					objSrc[key] = null
				}
			}
		}

		return objSrc
	},

	/**
	 * Get browser information
	 * @param {*} userAgent navigator.userAgent
	 * @returns
	 */
	browserDetect(userAgent) {
		const info = platform.parse(userAgent)

		if (window && window.navigator && (window.navigator.language || window.navigator.userLanguage)) {
			var userLang = window.navigator.language || window.navigator.userLanguage
		}

		return {
			browserName: info.name || '',
			browserVersion: info.version || '',
			product: platform.product || '',
			manufacturer: platform.manufacturer || '',
			layout: info.layout || '',
			operatingSystem: info.os || '',
			description: info.description || '',
			userAgent: userAgent || '',
			date: new Date().toString(),
			language: {
				accepted: acceptedlanguages.accepted,
				alternate: acceptedlanguages.alternate.length ? acceptedlanguages.alternate : [],
				relevant: acceptedlanguages.relevant.length ? acceptedlanguages.relevant : [],
				userLanguage: userLang || '',
			},
		}
	},
}

export default helper
